import { Field } from 'formik';
import { DatePicker as RsuiteDatePicker } from 'rsuite';
// import 'rsuite/dist/rsuite.min.css';

export const DatePicker = ({ name }) => {
  return (
    <Field name={name}>
      {({ meta, form: { values, setFieldValue } }) => (
        <div className="w-full">
          <p className="modal__form-el-label mb-2">Date of Birth</p>
          <RsuiteDatePicker
            name={name}
            onChange={(date) => {
              setFieldValue(name, date);
            }}
            value={values[name] || null}
            placement={'topStart'}
            oneTap={true}
            placeholder="MM-DD-YYYY"
            format={'MM-dd-yyyy'}
            className="custom-date-picker w-full h-[50px] rounded-[5px] text-[#92928F] flex items-center justify-between"
          />
          {meta.touched && meta.error && (
            <div className="error">{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
};
